<template>
    <div class="password_pop">
        <van-icon name="cross" class="close" @click="close"/>
        <p class="tit">请输入支付密码</p>
        <!-- 密码输入框 -->
        <van-password-input
          :value="value"
          :focused="showKeyboard"
          @focus="showKeyboard = true"
          :gutter="'1rem'"
        />
        <!-- 数字键盘 -->
        <van-number-keyboard
          :show="showKeyboard"
          @input="onInput"
          @delete="onDelete"
          @blur="showKeyboard = false"
          :hide-on-click-outside="false"
        />
    </div>
</template>

<script>
    export default {
        props: ['selection'],
        data() {
            return {
                value: '',
                showKeyboard: true
            }
        },
        computed: {},
        created() {},
        mounted() {},
        methods: {
            onInput(key) {
              this.value = (this.value + key).slice(0, 6);
            },
            onDelete() {
              this.value = this.value.slice(0, this.value.length - 1);
            },
            close() {
                this.$emit('handleClose')
            }
        },
        watch: {
            value: {
                immediate:true,
                handler(e) {
                    if(e.length == 6) {
                        this.$emit('handleFunc',{password: e})
                    }
                }
            }
        },
    }
</script>

<style lang="less" scoped>
.password_pop {
    height: calc(244px + 16rem);
    padding: 2.6rem;
    position: relative;
    background-color: #fbfbfb;
    .close {
        position: absolute;
        top: 1rem;
        right: 1rem;
        font-size: 2rem;
        color: #000;
        cursor: pointer;
    }
    .tit {
        text-align: center;
        font-size: 1.6rem;
        font-weight: 700;
        margin-bottom: 3rem;
    }
}
/deep/.van-password-input {
    margin: 0;
    .van-password-input__item {
        height: 4.5rem;
        background-color: #f5f5f5;
        border-radius: .8rem;
        &.van-password-input__item--focus {
            background-color: #d5d5d5;
        }
    }
}

/deep/.van-number-keyboard__body {
    .van-number-keyboard__keys {
        .van-key__wrapper:nth-last-child(3) {
            display: none;
        }
        .van-key__wrapper:nth-last-child(2) {
            flex: 2.05;
        }
        .van-key__wrapper:nth-last-child(1) {
            flex: 1;
        }
    }
    // .van-number-keyboard__sidebar {
    //     .van-key__wrapper:nth-last-child(1) {
    //         display: none;
    //         .van-key--blue {
    //             background-color: var(--theme);
    //         }
    //     }
    // }
}
</style>